import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useRoomI18nCatchCopy } from "./hooks";

export const QuestionRoomI18nCatchCopy = memo(() => {
	const { catchCopy, onSetMainTarget } = useRoomI18nCatchCopy();

	const onChange = (value: string) => {
		onSetMainTarget(value);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"キャッチコピー"}
			guide="ゲストに記事が表示される際のタイトルになります。短くシンプルなキャッチコピーにしましょう。100文字まで入力できます。"
			isEdited={catchCopy?.isEdited ?? false}
			hasError={Boolean(catchCopy?.error)}
			inputChildren={
				<InputTextField
					type="text"
					errorMessage={catchCopy?.error}
					value={catchCopy?.value ?? undefined}
					handleChange={onChange}
				/>
			}
		/>
	);
});

QuestionRoomI18nCatchCopy.displayName = "QuestionRoomI18nCatchCopy";
